import axios from 'axios'

let cachedContext = null
let pendingRequest = null

function hasOwn (value, key) {
  return Boolean(value) && Object.prototype.hasOwnProperty.call(value, key)
}

function valueOf (source, ...keys) {
  for (const key of keys) {
    if (hasOwn(source, key)) return source[key]
    const upper = String(key).toUpperCase()
    if (hasOwn(source, upper)) return source[upper]
  }
  return null
}

function stringArray (source, ...keys) {
  const value = valueOf(source, ...keys)
  if (!Array.isArray(value)) return []
  return Array.from(new Set(value
    .map(item => String(item || '').trim())
    .filter(Boolean)))
}

function accessContextError (detail) {
  const error = new Error(
    '利用可能な画面と操作を確認できませんでした。' +
    'いったんログアウトして再度ログインしてください。' +
    (detail ? `（${detail}）` : '')
  )
  error.code = 'ACCESS_CONTEXT_CONTRACT_MISMATCH'
  return error
}

export function normalizeAccessContext (data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw accessContextError('利用できる機能の情報を読み取れませんでした')
  }

  const accountId = Number(valueOf(data, 'accountId', 'account_id'))
  const userId = Number(valueOf(data, 'userId', 'user_id'))
  const planCode = String(valueOf(data, 'planCode', 'plan_code') || '').trim()
  const contractStatus = String(valueOf(data, 'contractStatus', 'contract_status') || '').trim()
  const roles = stringArray(data, 'roles')
  const features = stringArray(data, 'features')
  const permissions = stringArray(data, 'permissions')

  if (!Number.isFinite(accountId) || accountId <= 0) {
    throw accessContextError('契約企業を確認できません')
  }
  if (!Number.isFinite(userId) || userId <= 0) {
    throw accessContextError('利用者を確認できません')
  }
  if (!planCode || !contractStatus) {
    throw accessContextError('契約プラン情報が不足しています')
  }
  if (!roles.length) {
    throw accessContextError('有効な役割が設定されていません')
  }

  return {
    accountId,
    userId,
    planCode,
    contractStatus,
    roles,
    features,
    permissions
  }
}

export function setAccessContext (data) {
  cachedContext = normalizeAccessContext(data)
  return cachedContext
}

export function clearAccessContext () {
  cachedContext = null
  pendingRequest = null
}

export function getCachedAccessContext () {
  return cachedContext
}

export function getAccessContext (options = {}) {
  const force = Boolean(options.force)
  if (!force && cachedContext) return Promise.resolve(cachedContext)
  if (!force && pendingRequest) return pendingRequest

  pendingRequest = axios
    .get(process.env.VUE_APP_API_ORIGIN + '/access-context')
    .then(response => setAccessContext(response.data))
    .finally(() => {
      pendingRequest = null
    })

  return pendingRequest
}
